/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { useCurrentQueueItem } from "@packages/media";
import { MediaOptionsIcon, ModalTab } from "@packages/ui";

import type { MediaMenuTabProps } from "../MediaMenu.emotion";

export const SelectLengthTab = ({ disabled }: MediaMenuTabProps) => {
  const t = useTranslations();
  const { currentItem } = useCurrentQueueItem();

  return (
    <ModalTab
      key={"lengthSelectMenuTab"}
      value={"lengthSelectMenu"}
      startIcon={<MediaOptionsIcon />}
      label={t("track_settings_length")}
      disabled={disabled}
    >
      {currentItem.selected_audio.length}
    </ModalTab>
  );
};
